// extracted by mini-css-extract-plugin
export default {"input":"Toggle_input__WFk+l","label":"Toggle_label__v6Cnb"};